var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-backtop',{staticStyle:{"background-color":"#0089D0","color":"#fff"},attrs:{"target":".main-wrapper .main-scroll","visibility-height":50,"bottom":118}})}
var staticRenderFns = []

export { render, staticRenderFns }